import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Icon from 'flarum/common/components/Icon';
import FormGroup from 'flarum/common/components/FormGroup';
export default class BaseField {
  constructor(_ref) {
    let {
      field,
      stream
    } = _ref;
    _defineProperty(this, "field", void 0);
    _defineProperty(this, "stream", void 0);
    this.field = field;
    this.stream = stream;
  }

  /** Gets all Laravel validation rules split by rule. */
  validationRules() {
    return this.field.validation().split('|');
  }

  /** Gets a Laravel validation rule by name. */
  validationRule(ruleName) {
    let ruleContent = null;
    this.validationRules().forEach(rule => {
      const split = rule.split(':', 2);
      if (split[0] === ruleName) {
        ruleContent = split[1];
      }
    });
    return ruleContent;
  }
  editorField() {
    return m(FormGroup, Object.assign({
      stream: this.stream
    }, this.editorInputAttrs()));
  }
  editorInputAttrs() {
    return {
      type: 'text',
      label: this.fieldLabel(true),
      help: this.field.description(),
      required: this.field.required()
    };
  }
  fieldLabel(isEditor) {
    return m('[', null, this.field.icon() && m('[', null, m(Icon, {
      name: this.field.icon()
    }), ' '), this.field.name(), isEditor && this.field.required() ? '*' : null);
  }
  answerField() {
    if (app.forum.attribute('masquerade.hide-empty-fields') && !this.hasAnswer()) {
      return null;
    }
    const iconName = this.field.icon();
    return m("div", {
      className: `Masquerade-Bio-Set${this.hasAnswer() ? '' : ' Masquerade-Bio-Set--empty'}`
    }, m("span", {
      class: "Masquerade-Bio-Field"
    }, iconName && m('[', null, Icon.component({
      name: iconName
    }), ' '), this.field.name(), ":", ' '), m("span", {
      class: "Masquerade-Bio-Answer"
    }, this.answerContent()));
  }
  answerContent() {
    return this.stream();
  }
  hasAnswer() {
    const answerContent = this.answerContent();
    if (answerContent === null) {
      return false;
    }
    if (typeof answerContent === 'object') {
      return !!Object.keys(answerContent).length;
    }
    return !!answerContent?.length;
  }
  static isNoOptionSelectedValue(value) {
    // The value can be null when coming from the API
    // The value can be '' when the field does not exist on the user (the empty string is set in ProfileConfigurePane)
    return value === null || value === '';
  }
}
flarum.reg.add('fof-masquerade', 'forum/types/BaseField', BaseField);